export const NOVALA_FIELDS = [
  { value: 'ignore', label: 'Do not import' },
  { value: 'name', label: 'Account name', required: true },
  { value: 'number', label: 'Account number' },
  { value: 'accountType', label: 'Account type', required: true },
  { value: 'detailType', label: 'Detail type' },
  { value: 'description', label: 'Description' },
  { value: 'novalaBalance', label: 'Novala balance' },
];

export const VALID_ACCOUNT_TYPES = [
  'Bank', 'Accounts receivable (A/R)', 'Other current assets', 'Fixed assets', 'Other assets',
  'Accounts payable (A/P)', 'Credit card', 'Other current liabilities', 'Long-term liabilities',
  'Equity', 'Income', 'Other income', 'Expenses', 'Cost of goods sold', 'Other expense',
];

export const FIELD_SYNONYMS: Record<string, string> = {
  'account': 'name', 'account name': 'name', 'name': 'name',
  'account number': 'number', 'number': 'number', 'code': 'number', 'acct no': 'number',
  'type': 'accountType', 'account type': 'accountType', 'category': 'accountType',
  'detail type': 'detailType', 'subtype': 'detailType', 'detail': 'detailType',
  'description': 'description', 'notes': 'description', 'memo': 'description',
  'balance': 'novalaBalance', 'opening balance': 'novalaBalance',
  'novala balance': 'novalaBalance', 'current balance': 'novalaBalance',
};